import { useContext, useState, useEffect } from "react";
import { login } from "../../context/apiCalls";
import { AuthContext } from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "./com/AuthLayout";
import { AuthField, PasswordField } from "./com/AuthField";
import { primaryBtn, linkCls } from "./com/authStyles";

const LoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user, dispatch, error } = useContext(AuthContext);

  useEffect(() => {
    if (!user?.data) return;

    const timeout = setTimeout(
      () => navigate("/", { replace: true }),
      success ? 1000 : 0,
    );
    return () => clearTimeout(timeout);
  }, [success, user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setSuccess(false);
    try {
      await login({ username: username.trim(), password }, dispatch);
      setSuccess(true);
    } catch (err) {
      if (err?.response?.data?.needsVerification) {
        navigate("/verify-otp", { state: { username: username.trim() } });
        return;
      }
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      footerLeft={
        <>
          New to Vnoirs?{" "}
          <Link to="/signup" className={linkCls}>
            Create an account
          </Link>
        </>
      }
    >
      <form onSubmit={handleLogin} noValidate>
        <h1 className="m-0 mb-2 font-display text-[2rem] font-bold leading-[1.05] tracking-[-0.02em] min-[900px]:text-[2.4rem]">
          Welcome back
        </h1>
        <p className="m-0 mb-6 text-muted">
          Sign in to manage your stores and orders.
        </p>

        <div className="grid gap-4">
          <AuthField
            id="username"
            label="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
          />
          <PasswordField
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
        </div>

        <div className="mb-5 mt-3 flex justify-end">
          <Link
            to="/forgot-password"
            className={`text-[0.9rem] font-medium ${linkCls}`}
          >
            Forgot password?
          </Link>
        </div>

        {error && (
          <p
            role="alert"
            className="m-0 mb-4 rounded-2xl bg-[#fdecea] px-4 py-3 text-[0.92rem] text-[#8f2418]"
          >
            {error}
          </p>
        )}
        {!error && success && (
          <p
            role="status"
            className="m-0 mb-4 rounded-2xl bg-[#e3f5ec] px-4 py-3 text-[0.92rem] text-[#14704a]"
          >
            Signed in. Taking you to your dashboard…
          </p>
        )}

        <button type="submit" disabled={loading} className={primaryBtn}>
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </AuthLayout>
  );
};

export default LoginPage;
